














import { Component, Vue, Prop } from "vue-property-decorator";
import ChengduSettingDialog from "./chengduSettingDialog.vue";
@Component({
  components: {
    ChengduSettingDialog
  }
})
export default class ProjectZiduanZhusu extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private ziduan: any;
  private defaultValue: any = "";
  private dialogVisible: boolean = false;
  private ziduanChange() {
    this.$emit("update:ziduanChange", this.ziduan);
  }
  /**
   * @description 设置主诉
   */
  private zhusuSet() {
    this.dialogVisible = true;
  }
}
